module.exports = __webpack_public_path__ + "img/couples_05_V.2773e444.webp";